module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.4ced2a97.woff";